export default {
      id: "oc-user-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-user",
      toString: function () {
        return this.url;
      }
    }